import * as React from 'react';
import * as PXBColors from '@brightlayer-ui/colors';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { IconButton, InputAdornment, TextField } from '@mui/material';
import { Close, Search } from '@mui/icons-material';

export interface Props {
    value: string;
    callback: (search: string) => void;
    isDisabled?: boolean;
    testId: string;
}

const TableSearchInput: React.FunctionComponent<Props> = (props) => {

    const { value, callback, isDisabled = false, testId } = props;

    const { t } = useLanguageLocale();

    const [search, setSearch] = React.useState<string>('');
    const [charLenMessage, showCharLenMessage] = React.useState<boolean>(false);

    const handleSearch = (e: any) => {
        const { value } = e.target;
        setSearch(value);
        callback(value);

        if (value.length > 0 && value.length < 3) {
            showCharLenMessage(true);
        } else {
            showCharLenMessage(false);
        }
    }

    const handleResetSearch = () => {
        setSearch('');
    }

    return (
        <div style={{ display: 'inline-flex', flexDirection: 'column', alignItems: 'flex-start' }}>
            <TextField
                disabled={isDisabled}
                data-testid={testId}
                inputProps={{ maxLength: 100 }}
                value={search}
                style={{
                    width: 'auto',
                    textAlign: 'right',
                    border: '0px solid #727E84',
                    borderRadius: 5,
                    backgroundColor: 'white',
                    height: 32,
                    borderBlock: 0,
                    outline: 'none',
                    overflow: 'hidden',
                    marginTop: 28,
                    fontFamily: 'Open sans',
                    fontSize: 14,
                    color: '#727E84',
                    fontStyle: 'normal',
                    fontWeight: 400,
                    caretColor: PXBColors.blue[500]
                }}
                placeholder={t('ORGANIZATION_MANAGE.SEARCH_BUILDINGS')}
                onChange={handleSearch}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Search data-testid="search-icon" style={{ color: PXBColors.gray[500] }} />
                        </InputAdornment>
                    ),
                    endAdornment: (
                        <InputAdornment position="end">
                            {value !== '' && (
                                <IconButton onClick={handleResetSearch}>
                                    <Close fontSize="small" />
                                </IconButton>
                            )}
                        </InputAdornment>
                    ),
                }}
                variant="standard"
            />
            {
                charLenMessage &&
                <label style={{ color: PXBColors.red[500], fontSize: 13 }}>{t('FORMS.MINIMUM_3_CHAR_REQUIRED')}</label>
            }
        </div>
    );
};

export default TableSearchInput;
